// Enum esperado en backend
// eslint-disable-next-line no-shadow
export enum BulkLoadType {
  SINISTER = 'SINISTER',
  STATUS_PERSON = 'STATUS_PERSON',
}
